import React from 'react';
import PropTypes from 'prop-types';

const NoFaresBehavior = ({ behavior }) => {
  return <div data-em-qa-hint={`noFaresBehavior: ${behavior}`} />;
};

NoFaresBehavior.propTypes = {
  behavior: PropTypes.string,
};

NoFaresBehavior.defaultProps = {
  behavior: 'hidden',
};

export default NoFaresBehavior;
